import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PersonalData from './pages/PersonalData';
import PaymentData from './pages/PaymentData';
import './App.css';
import ErrorPage from './pages/ErrorPage';
import Home from './pages/Home';
import RecapPage from './pages/RecapPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/recap" element={<RecapPage />} />
        <Route path="/personal-data" element={<PersonalData />} />
        <Route path="/payment-data" element={<PaymentData />} />
        <Route path="/error" element={<ErrorPage />} />
      </Routes>
    </Router>
  );
}

export default App;